import { Component, OnInit, ViewChild, Input, Pipe, Injectable, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PrintService } from '../../../../../../src/app/ncs/services/print.service';
import { ServicesByCategoryCodeRequest, ServiceCategoriesController, ServiceCategoriesRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { ServicesByCategoryCodeController } from '../../../../../../src/app/ncs/models/actor/actor';
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
import { NgbModal, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ServiceConfigurationInfoPipe } from '../../testnurse/service/service.component';
import { HCPService } from '../../../../../../src/app/ncs/services/hcp.service';
import * as alertFunctions from '../../../../shared/data/sweet-alerts';

import { ServiceCategoryPipe } from '../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../../../src/app/shared/services/toastr.service';
import { CustomDateTimeService } from '../../../../../../src/app/ncs/services/datetime.service';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';



@Component({
  selector: 'printservices',
  templateUrl: './printservices.component.html',
  styleUrls: ['./printservices.component.scss']
})

export class PrintServicesComponent implements OnInit {
 @Input() ServiceCode: number;
  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;
  public invoiceDetails: any;
  //public ServiceCode: string;
  CurrentServiceCategoriesController: ServiceCategoriesController[];
  CurrentServiceCategoriesRequest: ServiceCategoriesRequest;
  ServicesByCategoryCodeGetRequest: ServicesByCategoryCodeRequest;
  ServicesByCategoryCodeController: ServicesByCategoryCodeController[];
  LoadServicesByCategory() {

    this.ServicesByCategoryCodeGetRequest = new ServicesByCategoryCodeRequest();
   
    this.ServicesByCategoryCodeGetRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.ServicesByCategoryCodeGetRequest.ServiceCategory = this.route.snapshot.paramMap.get('Code');// AppData.Instance().UserLoginDetails.FacilityActorCode;

    this.ServicesByCategoryCodeController = new Array<ServicesByCategoryCodeController>();
    this.GetServicesByCategoryCodeController();

  }
  onDataReady() {
    setTimeout(() => {
      window.print();
      this.isPrinting = true;
      this.router.navigate([{ outlets: { print: null } }]);
    });
  }
  isPrinting = false;
  GetServicesByCategoryCodeController() {
    this.StartRefreshing();
    this.actorservice.GetServicesByCategoryCodeController(this.ServicesByCategoryCodeGetRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        //alert(this.ApiResData.ErrorData);
        if (!this.ApiResData.hasError) {

          this.ServicesByCategoryCodeController = this.ApiResData.Result;
          this.invoiceDetails = this.ServicesByCategoryCodeController;
          //this.pdata2 = this.ServicesByCategoryCodeController;
        //  this.router.navigate('print/print')


          this.stopRefreshing();
          this.onDataReady();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }

  constructor(private router: Router,
    private actorservice: ActorService,
    private route: ActivatedRoute, private hcpservice: HCPService, private loaderService: SpinnerService,
    private modalService: NgbModal, private filter: ServiceConfigurationInfoPipe, private filter2: ServiceCategoryPipe, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService, 
   
    public printService: PrintService) {

    
  }


  ngOnInit() {
    //this.ServiceCode = this.route.snapshot.paramMap.get('Code');
    this.LoadServicesByCategory();
 
    
  }

  //onPrintInvoice() {
  //  const invoiceIds = this.route.snapshot.paramMap.get('Code');
  //  this.printService.printDocument(this.invoiceDetails,invoiceIds)
   
  //}
  

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}
